import React, { useState, useRef } from 'react';
import { THEME } from '../../utils/theme';

const MobileFilterSheet = ({ isOpen, onClose, typeFilter, setTypeFilter, sortBy, setSortBy, onlineOnly, setOnlineOnly, controllerFilter, setControllerFilter, unratedOnly, setUnratedOnly, userFavoritesFilters, setUserFavoritesFilters, userRecommendationsFilters, setUserRecommendationsFilters, squadMembers }) => {
  const [dragY, setDragY] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const startY = useRef(0);

  const handleTouchStart = (e) => {
    startY.current = e.touches[0].clientY;
    setIsDragging(true);
  };
  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const diff = e.touches[0].clientY - startY.current;
    if (diff > 0) setDragY(diff);
  };
  const handleTouchEnd = () => {
    setIsDragging(false);
    if (dragY > 100) onClose();
    setDragY(0);
  };

  if (!isOpen) return null;

  return (
    <>
      <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000 }} onClick={onClose} />
      <div
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          maxHeight: '70vh',
          background: THEME.bgCard,
          borderTopLeftRadius: '20px',
          borderTopRightRadius: '20px',
          zIndex: 1001,
          animation: 'slideInUp 0.3s ease-out',
          transform: `translateY(${dragY}px)`,
          transition: isDragging ? 'none' : 'transform 0.3s ease-out',
          overflowY: 'auto'
        }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {/* Drag Handle */}
        <div style={{ display: 'flex', justifyContent: 'center', padding: '12px' }}>
          <div style={{ width: '40px', height: '4px', background: THEME.borderLight, borderRadius: '2px' }} />
        </div>

        <div style={{ padding: '0 20px 24px' }}>
          <h3 style={{ margin: '0 0 20px', color: THEME.text, fontSize: '18px', fontWeight: '700' }}>Filters</h3>

          {/* Sort */}
          <div style={{ marginBottom: '20px' }}>
            <div style={{ fontSize: '12px', color: THEME.textMuted, marginBottom: '8px', fontWeight: '600' }}>Sort By</div>
            <select value={sortBy} onChange={e => setSortBy(e.target.value)} style={{
              width: '100%', background: THEME.bg, border: `1px solid ${THEME.border}`,
              borderRadius: '12px', padding: '14px', color: THEME.text, fontSize: '15px'
            }}>
              <option value="playtime">Combined Playtime</option>
              {squadMembers && squadMembers.length > 0 ? squadMembers.slice(0, 2).map(m => (
                <option key={`pt_${m.username}`} value={`playtime_${m.username}`}>{m.display_name || m.username}'s Playtime</option>
              )) : (
                <>
                  <option value="playtime_omega">Omega's Playtime</option>
                  <option value="playtime_supe">Supe's Playtime</option>
                </>
              )}
              <option value="name">Name (A-Z)</option>
              <option value="metacritic">Metacritic</option>
              <option value="rating">Rating</option>
            </select>
          </div>

          {/* Type Filter */}
          <div style={{ marginBottom: '20px' }}>
            <div style={{ fontSize: '12px', color: THEME.textMuted, marginBottom: '8px', fontWeight: '600' }}>Game Type</div>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {[{ value: 'all', label: 'All' }, { value: 'co-op', label: 'Co-op' }, { value: 'pvp', label: 'PvP' }, { value: 'mmo', label: 'MMO' }].map(opt => (
                <button key={opt.value} onClick={() => setTypeFilter(opt.value)} className="press-effect" style={{
                  background: typeFilter === opt.value ? `linear-gradient(135deg, ${THEME.omega}, ${THEME.supe})` : THEME.bg,
                  color: typeFilter === opt.value ? '#000' : THEME.text,
                  border: `1px solid ${typeFilter === opt.value ? 'transparent' : THEME.border}`,
                  borderRadius: '20px',
                  padding: '10px 18px',
                  fontSize: '13px',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}>{opt.label}</button>
              ))}
            </div>
          </div>

          {/* Controller Support */}
          <div style={{ marginBottom: '20px' }}>
            <div style={{ fontSize: '12px', color: THEME.textMuted, marginBottom: '8px', fontWeight: '600' }}>Controller Support 🎮</div>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {[{ value: '', label: 'Any' }, { value: 'any', label: 'Has Support' }, { value: 'full', label: 'Full' }, { value: 'partial', label: 'Partial' }].map(opt => (
                <button key={opt.value} onClick={() => setControllerFilter(opt.value)} className="press-effect" style={{
                  background: controllerFilter === opt.value ? `linear-gradient(135deg, ${THEME.success}, #22c55e)` : THEME.bg,
                  color: controllerFilter === opt.value ? '#000' : THEME.text,
                  border: `1px solid ${controllerFilter === opt.value ? 'transparent' : THEME.border}`,
                  borderRadius: '20px',
                  padding: '10px 18px',
                  fontSize: '13px',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}>{opt.label}</button>
              ))}
            </div>
          </div>

          {/* Toggles */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '20px' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer', padding: '8px 0' }}>
              <div style={{
                width: '24px', height: '24px', borderRadius: '6px',
                background: onlineOnly ? `linear-gradient(135deg, ${THEME.omega}, ${THEME.supe})` : THEME.bg,
                border: `2px solid ${onlineOnly ? 'transparent' : THEME.border}`,
                display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s'
              }} onClick={() => setOnlineOnly(!onlineOnly)}>
                {onlineOnly && <span style={{ color: '#fff', fontSize: '14px' }}>✓</span>}
              </div>
              <span style={{ color: onlineOnly ? THEME.text : THEME.textMuted, fontSize: '15px' }}>Online Multiplayer Only</span>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer', padding: '8px 0' }}>
              <div style={{
                width: '24px', height: '24px', borderRadius: '6px',
                background: unratedOnly ? `linear-gradient(135deg, ${THEME.omega}, ${THEME.supe})` : THEME.bg,
                border: `2px solid ${unratedOnly ? 'transparent' : THEME.border}`,
                display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s'
              }} onClick={() => setUnratedOnly(!unratedOnly)}>
                {unratedOnly && <span style={{ color: '#fff', fontSize: '14px' }}>✓</span>}
              </div>
              <span style={{ color: unratedOnly ? THEME.text : THEME.textMuted, fontSize: '15px' }}>Unrated Games Only</span>
            </label>
            {/* Dynamic user favorites filters */}
            {(squadMembers || []).map(member => {
              const isChecked = userFavoritesFilters[member.username] || false;
              const userColor = member.theme_color || THEME.success;
              return (
                <label key={member.username} style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer', padding: '8px 0' }}>
                  <div style={{
                    width: '24px', height: '24px', borderRadius: '6px',
                    background: isChecked ? userColor : THEME.bg,
                    border: `2px solid ${isChecked ? 'transparent' : THEME.border}`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s'
                  }} onClick={() => setUserFavoritesFilters(prev => ({ ...prev, [member.username]: !isChecked }))}>
                    {isChecked && <span style={{ color: '#fff', fontSize: '14px' }}>✓</span>}
                  </div>
                  <span style={{ color: isChecked ? THEME.text : THEME.textMuted, fontSize: '15px' }}>★ {member.display_name} Favorites</span>
                </label>
              );
            })}
          </div>

          {/* Apply Button */}
          <button onClick={onClose} className="press-effect" style={{
            width: '100%',
            background: `linear-gradient(135deg, ${THEME.omega}, ${THEME.supe})`,
            color: '#000',
            border: 'none',
            borderRadius: '12px',
            padding: '16px',
            fontSize: '15px',
            fontWeight: '700',
            cursor: 'pointer'
          }}>
            Apply Filters
          </button>
        </div>
      </div>
    </>
  );
};

export default MobileFilterSheet;
